import styled from "styled-components";

export const MainSection = styled.section`
  flex: 2;
`;

export const HeaderSection = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 1rem 0;
`;

export const Title = styled.h2`
  font-size: 1.5rem;
  margin: 0 0 0.25rem;
`;

export const CoverImageContainer = styled.div`
  position: relative;
  width: 100%;
  overflow: hidden;
  border-radius: 8px;
`;

export const CoverImage = styled.img`
  width: 100%;
  height: auto;
  display: block;
`;

export const OrganizerText = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-top: 0.75rem;
  letter-spacing: 0%;
  font-family: "Inter", sans-serif;
  color: #8f8f8f;
  line-height: 1.75rem;
  font-size: 1rem;
  justify-content: space-between;
`;

export const OrganizerInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;

export const OrganizerName = styled.span`
  font-weight: bold;
`;

export const LocationInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  color: #757575;
  font-size: 0.875rem;

  svg {
    flex-shrink: 0;
  }
`;

export const Description = styled.p`
  margin: 1rem 0 0;
  line-height: 1.6;
`;